// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"673":"178257d4","767":"9a3cbeb4"}[chunkId] + ".chunk.js";
};